import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import TvMinimalPlay from '@/assets/icons/tvMinimalPlay.svg?react';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useAuth } from '@/hooks/useAuth';
import useScreenSize from '@/hooks/useScreenSize';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

const DemoBanner = () => {
  const { windowWidth } = useScreenSize();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleQuitDemo = () => {
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'mode demo',
      event_nom: 'quitter le mode demo',
      event_metier: 'espace client placement',
      event_detail_1: 'cta',
      event_detail_2: 'bandeau demo',
    });
    logout();
    navigate('/', { replace: true });
  };

  return (
    <div className={styles.demoBanner}>
      <div className={styles.demoBannerContent}>
        {windowWidth > BREAKPOINTS.tablet && (
          <TvMinimalPlay
            className={styles.demoBannerIcon}
            height={24}
            width={24}
            color="var(--totem-text-color-secondary)"
          />
        )}
        <div className={styles.demoBannerText}>
          <strong>{t('demoMode.banner.title')}</strong>
          <span>
            {windowWidth > BREAKPOINTS.tablet ? t('demoMode.banner.subtitle') : t('demoMode.banner.subtitleMobile')}
          </span>
        </div>
        <button className={styles.demoBannerButton} onClick={handleQuitDemo}>
          <span>
            {windowWidth > BREAKPOINTS.tablet ? t('demoMode.banner.button') : t('demoMode.banner.buttonMobile')}
          </span>
        </button>
      </div>
    </div>
  );
};

export default DemoBanner;
